/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GetOtp.vue?vue&type=template&id=5c859aa2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports